import { TooltipProvider } from '@1trading/react';
import { QueryClientProvider } from '@tanstack/react-query';
import type React from 'react';
import { ConfirmActionDialogHost } from '@/components/dialogs/confirm-action-dialog';
import { Toaster } from '@/components/ui/toaster';
import { queryClient } from '@/lib/query-client';
import { ThemeProvider } from '@/lib/theme-provider';

const TOOLTIP_DELAY_DURATION_MS = 100;

// Phase 2 inserts AuthProvider + UserContext between QueryClientProvider and ThemeProvider.
const Providers = ({ children }: React.PropsWithChildren) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider delayDuration={TOOLTIP_DELAY_DURATION_MS}>{children}</TooltipProvider>
        <Toaster />
        <ConfirmActionDialogHost />
      </ThemeProvider>
    </QueryClientProvider>
  );
};
Providers.displayName = 'Providers';

export default Providers;
